import type {StreamTab_activity$data} from './__generated__/StreamTab_activity.graphql';
import type {StreamEntry} from './StreamHistoryCard';
import {resolveMentions} from '../utils/resolveMentions';

type RawEntry = StreamTab_activity$data[number];

export function normaliseForStream(entry: RawEntry | {__typename: string; [key: string]: unknown}): StreamEntry | null {
	switch (entry.__typename) {
		case 'MessageActivity': {
			const e = entry as Extract<RawEntry, {readonly __typename: 'MessageActivity'}>;
			const isOutbound = e.direction === 'outbound' || e.authorType === 'agent';
			const actorName = e.author ? e.author.fullName ?? 'Deleted user' : isOutbound ? 'Agent' : 'Requester';
			return {
				id: e.id,
				type: isOutbound ? 'email-sent' : 'email-received',
				actorName,
				actorInitial: actorName.charAt(0).toUpperCase(),
				body: e.body,
				bodyHtml: e.bodyHtml,
				createdAt: e.createdAt as string,
			};
		}
		case 'InternalCommentActivity': {
			const e = entry as Extract<RawEntry, {readonly __typename: 'InternalCommentActivity'}>;
			const actorName = e.author ? e.author.fullName ?? 'Deleted user' : 'Agent';
			const names = Object.fromEntries((e.mentionedUsers ?? []).map(u => [u.id, u.fullName ?? 'Deleted user']));
			return {
				id: e.id,
				type: 'internal-note',
				actorName,
				actorInitial: actorName.charAt(0).toUpperCase(),
				body: resolveMentions(e.body, names),
				createdAt: e.createdAt as string,
			};
		}
		default:
			return null;
	}
}
